import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import moment from "moment";
import Sidebar from "../components/dashboard/sidebar";
import { contentContext } from "../context/contentContext";
import DataTable from 'react-data-table-component';
import tmdbApi from "../api/tmdbApi";
import SessionPopup from "../pages/SessionPopup";
// import LocationSearch from "../LocationSearch";
import TableLoader from "../components/tableLoader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-bootstrap/Modal';
//  import { withGoogleMap, GoogleMap, withScriptjs} from "react-google-maps";
import { GoogleMap, LoadScript } from "@react-google-maps/api";

let { lambda, appname } = window.app
const Transactions = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    // const [isLoading, setIsLoading] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const userId = localStorage.getItem("userId");
    const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
    // // console.log('loginType',loginType,localStorage.getItem("clientid"));
    const useruniqueid = loginType === 'admin' ? localStorage.getItem("userId") : localStorage.getItem("clientid")
    // console.log('useruniqueid', useruniqueid);
    const {searchedFlag, setSearchedFlag,clientmanagesearch,setClientMangeSearch,  isLoading, setIsLoading,userData, setUserData,GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch ,currentPage, setcurrentPage, data, setData,rowsPerPage, setRowsPerPage,currentPageNew, setCurrentPage,route, setRoute,usePrevious, setActiveMenuId,  GetTimeActivity} = useContext(contentContext)
    const [add, setAdd] = useState(false);
    const [message, setMessage] = useState(false);
    const [loaderEnable, setLoaderEnable] = useState(false);
    const [selectedPlace, setSelectedPlace] = useState('');
    const [addressData, setAddressData] = useState({});

    // const [mapsAPIkey, setMapsAPIkey] = useState({});
    const [locationFlag, setLocationFlag] = useState(false);
    const [uploadImg, setUploadImg] = useState('');
    const [filesData, setFilesData] = useState([])
    const [fileSizeError, setFileSizeError] = useState(false);
    const [dynamicQuizId, setLocationId] = useState(null);
    const [files, setFiles] = useState([]);
    const [markers, setMarkers] = useState([]);
    const [storeFiles, setStoreFiles] = useState([])
    const [multiUploadFiles, setMultiUploadFiles] = useState([]);
    const [imageLogo, setImageLogo] = useState([]);
    // const [data, setData] = useState([])
    const [editData, setEditData] = useState({
        maxVisitor: 0,
        maxPartySize: 0,
        codeExpiration: 0,
        automatedExit: 0,
        visitDuration: 15,
        maxLocationCapacity: 0,
        // basicPlan: {},
        // premiumPlan: {},
        // vipPlan: {}
    })
    const [mapaddress, setMapAddress] = useState({})
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [deleteLoad, setDeleteLoad] = useState({});
    const [deletePopup, setDeletePopup] = useState(false);
    const [deleteLogo, setDeleteLogo] = useState({});
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("");// State for dynamic message
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [countries, setCountries] = useState('');
    const [image, setImg] = useState('')
    const [idc, setIdc] = useState("USA(+1)");
    const [IdcError, setIdcError] = useState('');
    const [preferenceStatus, setPreferenceStatus] = useState(false)
    const [spotsStatus, setSpotsStatus] = useState(false)
    const [locationStatus, setLocationStatus] = useState(true)
    const [updateFlagValue, setUpdateFlagValue] = useState(false)
    const [percentageValue, setPercentagevalue] = useState(100)
    const [activeTab, setActiveTab] = useState("clients");
    const [tableData, setTableData] = useState([]);
    const [tempValue, setTempValue] = useState(0);
const [transactionsData,setTransactionsData]=useState([])
const [columns, setColumns] = useState([]);
    // useEffect(() => {
    //     setIsLoading(true);
    //     // Simulate API loading
    //     setTimeout(() => {
    //         if (activeTab === 'clients') {
    //             setTableData(clientsData);
    //         } else {
    //             setTableData(visitorsData);
    //         }
    //         setIsLoading(false);
    //     }, 500);
    // }, [activeTab]);
    useEffect(()=>{
        getTransactionData()
    },[])
    useEffect(() => {

        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setRoute("client")
        setActiveMenuId(200006)

        // setActiveMenuObj({
        //     "Client Management": true,
        //     "Contact Management": false,
        //     "Reports": false
        // })
        // if (search === true) {
        //     handleSearch();

        // } else {
        //     client();
        //   //   GetCountries();
        // }
        userActivity();

    }, []);
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }
    // Dummy data for example
    const clientsData = [
        { _id: 1, name: "John Doe", email: "john@example.com" },
        { _id: 2, name: "Jane Smith", email: "jane@example.com" },
    ];

    const visitorsData = [
        { _id: 3, name: "Visitor One", email: "visitor1@example.com" },
        { _id: 4, name: "Visitor Two", email: "visitor2@example.com" },
    ];
    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const clientsColumns  = [

        {
            name: 'Transaction Id',
            selector: row => row?.transactionId ?? "",
            sortable: true,
        },
        {
            name: 'First Name',
            selector: row => row?.address?.firstName ?? "",
            sortable: true,
        },
        
        // {
        //     name: 'Type',
        //     selector: row => row?.type ?? "",
        //     sortable: true,
        // },
        {
            name: 'Last Name',
            selector: row => row?.address?.lastName ?? "",
            sortable: true,
        },
        {
            name: 'EmailId',
            selector: row => row?.address?.email ?? "",
            sortable: true,
        },
        {
            name: 'Plan Type',
            selector: row => row?.planType
                ?? "",
            sortable: true,
        },
        // {
        //     name: 'ACCOUNT MANAGER',
        //     // selector: row => row && row.companydetails && row.companydetails[0] && row.companydetails[0].accountmanager && row?.companydetails[0]?.accountmanager && row?.companydetails[0]?.accountmanager !== undefined && row?.companydetails[0]?.accountmanager !== "" ? row?.companydetails[0]?.accountmanager : "",
        //     selector: row => row?.companydetails?.[0]?.accountmanager ?? '',

        //     sortable: true,
        // },
        // {
        //     name: 'Entity',
        //     selector: row => row?.entity ?? "",
        //     sortable: true,
        // },
        {
            name: 'Currency',
            selector: row => row?.currency,
            sortable: true,
      
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },
        {
            name: 'Pay Amount',
            selector: row => row?.payAmount ?? "",
            sortable: true,
        },
        {
            name: 'Grand Total',
            selector: row => row?.grandTotal ?? "",
            sortable: true,
        },
        // {
        //     name:
        //         //  <>
        //         // {(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 
        //         // 'Actions' : null}</>
        //         'Actions'
        //     ,
        //     cell: (props) =>
        //         //  {
        //              subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
        //         <div className="d-flex">
        //             {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
        //             <a onClick={e => handleViewClient(e, props.clientid)}
        //                  className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}

        //                 // className={` text-success action-button`}
        //             ><i className="mdi mdi-eye font-size-18"></i></a>
        //              } 
        //             {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true &&
        //             <a onClick={e => handleEditClient(e, props.clientid)} style={{ position: "inherit" }}
        //                 className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}
        //                 // className={`text-danger action-button`}
        //             ><i className="mdi mdi-pencil font-size-18"></i></a>
        //             }
        //             {/* {localStorage.getItem("clientid")===props?.clientid?} */}
        //               <a  style={{ position: "inherit"}} 
        //               onClick={()=>handleDelete(props?.clientid)}
        //                 // className={`${subValDashboard && subValDashboard.delete && subValDashboard.delete.enable === false ? 'pe-none' : ''} text-danger action-button`}
        //                 className={`text-danger action-button ${localStorage.getItem("clientid")===props?.clientid || props?.status==="ARCHIVE"?"pe-none":""}`}
        //                 ><i className="mdi mdi-delete font-size-18"></i></a>
        //         </div>
        //     //  }
        //     ,
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        //     button: true,
        // },
    ];
    const visitorsColumns  = [

        {
            name: 'Transaction Id',
            selector: row => row?.transactionId ?? "",
            sortable: true,
        },
        {
            name: 'Plan',
            selector: row => row?.plan ?? "",
            sortable: true,
        },
        
        
        // {
        //     name: 'Last Name',
        //     selector: row => row?.address?.lastName ?? "",
        //     sortable: true,
        // },
        // {
        //     name: 'EmailId',
        //     selector: row => row?.address?.email ?? "",
        //     sortable: true,
        // },
        {
            name: 'Total Amount',
            selector: row => row?.totalAmount
                ?? "",
            sortable: true,
        },
        // {
        //     name: 'ACCOUNT MANAGER',
        //     // selector: row => row && row.companydetails && row.companydetails[0] && row.companydetails[0].accountmanager && row?.companydetails[0]?.accountmanager && row?.companydetails[0]?.accountmanager !== undefined && row?.companydetails[0]?.accountmanager !== "" ? row?.companydetails[0]?.accountmanager : "",
        //     selector: row => row?.companydetails?.[0]?.accountmanager ?? '',

        //     sortable: true,
        // },
        // {
        //     name: 'Entity',
        //     selector: row => row?.entity ?? "",
        //     sortable: true,
        // },
        {
            name: 'Currency',
            selector: row => row?.currency,
            sortable: true,
      
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },
        {
            name: 'created on',
            selector: row => row?.created ?? "",
            cell: (props) => props.created ? moment.utc(props.created).format("MM-DD-YYYY") : "",
            sortable: true,
        },
        // {
        //     name: 'status',
        //     selector: row => row?.status ?? "",
        //     sortable: true,
        // },
        // {
        //     name:
        //         //  <>
        //         // {(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 
        //         // 'Actions' : null}</>
        //         'Actions'
        //     ,
        //     cell: (props) =>
        //         //  {
        //              subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
        //         <div className="d-flex">
        //             {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
        //             <a onClick={e => handleViewClient(e, props.clientid)}
        //                  className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}

        //                 // className={` text-success action-button`}
        //             ><i className="mdi mdi-eye font-size-18"></i></a>
        //              } 
        //             {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true &&
        //             <a onClick={e => handleEditClient(e, props.clientid)} style={{ position: "inherit" }}
        //                 className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}
        //                 // className={`text-danger action-button`}
        //             ><i className="mdi mdi-pencil font-size-18"></i></a>
        //             }
        //             {/* {localStorage.getItem("clientid")===props?.clientid?} */}
        //               <a  style={{ position: "inherit"}} 
        //               onClick={()=>handleDelete(props?.clientid)}
        //                 // className={`${subValDashboard && subValDashboard.delete && subValDashboard.delete.enable === false ? 'pe-none' : ''} text-danger action-button`}
        //                 className={`text-danger action-button ${localStorage.getItem("clientid")===props?.clientid || props?.status==="ARCHIVE"?"pe-none":""}`}
        //                 ><i className="mdi mdi-delete font-size-18"></i></a>
        //         </div>
        //     //  }
        //     ,
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        //     button: true,
        // },
    ];
    const customNoRecords = () => {
        return(
            
            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No transactions were found</p>
                </div> </div>
        )
    }
    const getTransactionData = () => {
        setIsLoading(true);
        console.log('Client call');
        let url;
        let page = 1;
    
        setIsLoading(true);
    
        const token = localStorage.getItem("token");
        const userid = localStorage.getItem("userId");
    
      
            url = lambda + '/allTransactions?appname=' + appname + "&token=" + token;
        
    
        axios({
            method: 'POST',
            url: url
        })
        .then(function (response) {
            // If token validation is needed:
            if (response?.data?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true);
            } else {
          
            setTransactionsData(response?.data?.result)
            if(activeTab==="clients"){
                setData(response?.data?.result?.transactions);
                setColumns(clientsColumns)
            }else{
                // console.log("Responseeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",response?.data?.result?.visirorTransactions)
                setData(response?.data?.result?.visirorTransactions);
                setColumns(visitorsColumns)
            }
               
                setIsLoading(false)
                // setColumns(clientsColumns)
                // global.exportExcelData = response?.data?.result?.data;
                // setContent(response?.data?.result);
            }
    
        })
        .catch((err) => {
            console.log('Error:', err);
            setIsLoading(false);
        });
    };
console.log("columnssssssssssssssssssssssssssssssssssssss",columns)
    const clearSearch = () => {
        GetTimeActivity()
        setClientMangeSearch("");
     
        getTransactionData();
    }
    const handleSearch = (e, flagggg) => {
      
          
            console.log('handle search')
           
                // setLoaderEnable(true)
           
            const token = localStorage.getItem("token")
            const userid = localStorage.getItem("userId")
          
            // if (flagggg === "normalsearch") {
            //     setIsLoading(true)
            // }
            let urlLink;

            const searchParam = activeTab === "clients" ? "transactionSearch" : "visitorSearch";

           urlLink = `${lambda}/allTransactions?appname=${appname}&userid=${userid}&${searchParam}=${clientmanagesearch}&token=${token}`;
            

            // urlLink = lambda + '/clients?appname=' + appname + "&token=" + token + "&userid=" + userid

            // let payload = clientmanagesearch ? '' : { ...clientAdvSearch };

            // const result = processObject(clientAdvSearch);
            // setClientAdvSearch(result)
            axios({
                method: 'POST',
                url: urlLink,
                // data: payload,
                // data: result,
            })
                .then(function (response) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        // setShowSessionPopupup(true)
                        // setIsLoading(false)
                        // setShowPopup(false)
                    } else {
                        // console.log("response", response);
                        if(activeTab==="clients"){
                            setData(response?.data?.result?.transactions);
                        }else{
                            setData(response?.data?.result?.visirorTransactions);
                        }
                        
                        // global.exportExcelData = response?.data?.result?.data
                        // setContent(response?.data?.result);
                        // setIsLoading(false);
                        // setShowPopup(false)
                        // setLoaderEnable(false);
                        // if (flagggg === "click") {
                        //     setClientMangeSearch("")
                        // }
                    }
                }).catch((err) => {
                    console.log('error', err);
                    // setTableErrMsg(true)
                    // setIsLoading(false);
                });
        
    }
    const handleChange = (e) => {
        // if (e.target.value === "") {
        //     //client();
        //     setFlag(false)
        // }
        setClientMangeSearch(e.target.value)
    }

    const handlePageChange = (page) => {
        // GetTimeActivity()   
         setCurrentPage(page);
       };
     
       const handlePerRowsChange = (newPerPage) => {
        // GetTimeActivity()   
         setRowsPerPage(newPerPage);
       };
    
    const handleActiveTab=(tab)=>{
        if(tab==="clients"){
            setData(transactionsData?.transactions)
            setColumns(clientsColumns)
            setCurrentPage(1)
            setRowsPerPage(15)
        }else{
            setData(transactionsData?.visirorTransactions)
            setColumns(visitorsColumns)
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    //  transactionsData(tab)
        setActiveTab(tab)
        setClientMangeSearch("")
    }
   
    console.log("percentageValue plans", percentageValue, tempValue)
    let imageCloudFront = window?.site?.common?.imageCloudfront
    return (
        <>
           {showSessionPopupup && <SessionPopup />}
        <div id="layout-wrapper">
            <Header />
            <Sidebar />

            <div className="main-content user-management transaction-page">
                <div className="page-content">
                    <div className="container-fluid">

                        <div className="row mb-4 breadcrumb">
                            <div className="col-lg-12">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <h4 className="mb-2 card-title">Transactions</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row table-data">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body edit-store">
                                        {/* Tabs */}
                                        <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
    <li className="nav-item" role="presentation">
        <a
            id="transaction-clients"
            className={`nav-link ${activeTab === 'clients' ? 'active' : ''}`}
            onClick={() => handleActiveTab("clients")}
            role="tab"
        >
            <span className="d-none d-sm-block">CLIENTS</span>
        </a>
    </li>
    <li className="nav-item" role="presentation">
        <a
            id="transaction-visitors"
            className={`nav-link ${activeTab === 'visitors' ? 'active' : ''}`}
            onClick={() => handleActiveTab("visitors")}
            role="tab"
        >
            <span className="d-none d-sm-block">VISITORS</span>
        </a>
    </li>
</ul>


                                        <div className="tab-content p-3 text-muted">
                                            <div className="tab-pane active show add-client-details" role="tabpanel">
                                                <div className="row mb-2" id="table-header-row">
                                                    <div className="col-sm-4 button-block" id="button-block">
                                                        {/* Export Button Placeholder */}
                                                    </div>

                                                    <div className="col-sm-8">
                                                        <div className="search-box mb-2 d-inline-block" id="search-box">
                                                            <div className="position-relative">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={activeTab ==="clients" ? "Search by Name, Email or Transaction ID" : "Search by Plan, Transaction ID or Created"}
                                                                    value={clientmanagesearch}
                                                                onChange={(e) => handleChange(e)}
                                                                id={activeTab ==="clients" ? "client-input-search" : "visitor-input-search"}
                                                                />
                                                                <button className="fill_btn" id="search-btn"    onClick={(e) => handleSearch(e, "normalsearch")}>
                                                                    <span className="material-icons search-icon">search</span>
                                                                </button>
                                                            </div>

                                                            <div className="dataTables_length" id="datatable-length-reset">
                                                                <button className="fill_btn" id="reset-btn"  onClick={clearSearch}>
                                                                    <span className="material-icons-outlined">sync</span>Reset
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Common Table */}
                                                <DataTable
                                 id="categoriesTable"
                                 key={keyForRerender}
                                 columns={columns}
                                 keyField="_id"
                                 data={data}
                                 direction="auto"
                                 highlightOnHover
                                 fixedHeaderScrollHeight="300px"
                                 pagination
                                 responsive
                                 persistTableHead
                                 striped
                                 defaultSortField="name"
                                 noDataComponent={customNoRecords()}
                                 paginationTotalRows={data.length}
                                 onChangeRowsPerPage={handlePerRowsChange}
                                 onChangePage={handlePageChange}
                                 paginationPerPage={rowsPerPage}
                                 paginationDefaultPage={currentPageNew}
                                 paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                 paginationComponentOptions={{
                                   rowsPerPageText: 'Per page:',
                                   rangeSeparatorText: 'of',
                                   noRowsPerPage: false,
                                   selectAllRowsItem: false,
                                   selectAllRowsItemText: 'All',
                                 }}
                                 progressPending={isLoading}
                                 progressComponent={<TableLoader />}
                               />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ToastContainer
                    id="toastContainer"
                    position="bottom-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover={false}
                    theme="light"
                />

                <Footer />
            </div>
        </div>
    </>
    );
};

export default Transactions;
